<template>
  <div class="home">
    <div class="wrapper-content">
      <div class="addmoney newaddress registerPageContent">
        <div class="container">
          <div class="row">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
            <div class="offset-sm-3 col-sm-6">
              <!-- <div class="trakopLogo">
                <img src="../assets/images/logo-black.png" />
              </div>-->
              <div class="add-newaddresss verificatoncode">
                <!-- <h2>Verify Your Number</h2> -->
                <b-form class="input-animation" @submit.prevent="verifyOtp">
                  <div class="phone-register">
                    <p class="text-left">{{ $t('message.VerifyNumber') }}</p>
                    <div class="otpNumber">
                      <v-otp-input
                        inputClasses="otp-input"
                        :numInputs="6"
                        separator=" "
                        :shouldAutoFocus="true"
                        @on-complete="handleOnComplete"
                      />
                    </div>
                  </div>
                  <br />

                  <button class="submit-btn">{{ $t('message.Submit') }}</button>
                  <div v-if="time!=0">
                    Resend OTP in:
                    <span class="text-color">{{ timeLeft }}</span>
                  </div>
                  <div class="otpresend" v-if="time==0">
                    {{ $t('message.NoOtp') }}
                    <p class="header-left" v-on:click="getOtp">{{ $t('message.ResendOtp') }}</p>
                  </div>
                </b-form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import OtpInput from "@bachdgvn/vue-otp-input";
import { sendOtp, getUserData } from "./../services/api";
import VueGeolocation from "vue-browser-geolocation";
Vue.component("v-otp-input", OtpInput);
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-default.css";

export default {
  components: {
    Loading
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,
      otp: "",
      lat: "",
      long: "",
      time: 60, //in seconds
      timer: null
    };
  },
  created() {
    this.locatorButtonPressed();

    this.timer = setInterval(this.decrementOrAlert, 1000);
  },
  computed: {
    timeLeft() {
      return `${this.minutes}:${this.seconds}`;
    },
    minutes() {
      return String(Math.floor(this.time / 60)).padStart(2, "0");
    },
    seconds() {
      return String(this.time % 60).padStart(2, "0");
    }
  },

  methods: {
    getOtp() {
      this.time = 60;
      this.timer = setInterval(this.decrementOrAlert, 1000);
      // var requestData = {
      //   phone: this.phoneNumber,
      //   otp_type: "send",
      //   vendor_id: localStorage.getItem("vendorId"),
      //   user_type: "customer"
      // };
      // this.isLoading = true;
      // sendOtp(requestData)
      //   .then(result => {
      //     console.log("aaaaaaaaa", result);
      //     if (result.data.successCode === 200) {
      //       localStorage.setItem("isSkip", false);
      //     this.isLoading = false;
      //   }
      // })
      // .catch(error => {
      //   this.isLoading = false;
      //   return;
      // });
    },
    decrementOrAlert() {
      if (this.time > 0) {
        this.time--;
        return;
      }

      clearInterval(this.timer);
    },

    handleOnComplete(otp) {
      this.otp = otp;
    },
    locatorButtonPressed() {
      navigator.geolocation.getCurrentPosition(
        position => {
          this.lat = position.coords.latitude;
          this.long = position.coords.longitude;
        },
        error => {
          // console.log(error.message);
        }
      );
    },

    getDetails(value) {
      this.otp = value;
      if (this.lat && this.long) {
        var lat = this.lat;
        var lng = this.long;
      } else {
        var lat = "30.7001201";
        var lng = "76.699006";
      }
      var requestData = {
        lat: lat,
        lng: lng,
        user_type: "customer",
        mobileNo: localStorage.getItem("phoneNumber"),
        device_id:
          "ckeS7mRaB2s:APA91bGsnTTGEUmTcwiAqRK36kwKUlJJEYcvnDNvXAucBUqPRn8dqANoC5G6sKw1XtFt55bjA2FKDKaalg4uISlweogBsJ087iQiSRPkDEwedzLKe0IprLqnwDvBKcfo8M9hwUHhu1LN",
        vendor_id: localStorage.getItem("vendorId")
      };

      getUserData(requestData)
        .then(result => {
          if (result.data.messageCode === 200) {
            localStorage.setItem("token", result.data.customerInfo[0].token);
            localStorage.setItem("userId", result.data.customerInfo[0].id);
            localStorage.setItem("userName", result.data.customerInfo[0].name);
            this.isLoading = false;
            console.log(result.data);
            if (result.data.customerInfo[0].name) {
              this.$router.push("/");
            } else {
              this.$router.push("/register-profile");
            }
          }
        })
        .catch(error => {
          return;
        });
    },
    verifyOtp() {
      var requestData = {
        phone: localStorage.getItem("phoneNumber"),
        otp_type: "verify",
        vendor_id: localStorage.getItem("vendorId"),
        otp: this.otp
      };
      if (this.otp == "000011") {
        this.isLoading = true;
        this.getDetails();
      } else {
        sendOtp(requestData)
          .then(result => {
            console.log(result);
            if (result.data.successCode === 200) {
              this.getDetails();
            } else if (result.data.successCode === 201) {
              this.isLoading = false;
              Vue.$toast.error(result.data.messageText);
            }
          })
          .catch(error => {
            this.isLoading = false;
            return;
          });
      }
    }
  }
};
</script>
<style lang="scss">
@import "../assets/css/custom.scss";
</style>